import { FC } from "react";

import { Divider as DividerBase, DividerProps } from "@chakra-ui/react";

const Divider: FC<DividerProps> = (props) => (
  <DividerBase borderColor="grey.outline" borderBottomWidth="1px" {...props} />
);

export default Divider;
